import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/home/how-it-works/tomas.webp")